module.exports = __webpack_public_path__ + "img/digi-back-arrow.d4f7ee9a.png";